<template>
<svg xmlns="http://www.w3.org/2000/svg" 
    :fill="fill"
    :stroke="stroke"
    width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
</template>
<script>
export default {
  props: {
    width: {
      default: 5,
    },
    height: {
      default: 6,
    },
    fill:{
        default: 'currentColor',
    },
    stroke:{
        default: 'currentColor',
    }
  },
};
</script>
